import { __extends } from "tslib";
import * as _ from '@antv/util';
import { registerPlotType } from '../../base/global';
import BaseBulletLayer, { STACK_FIELD } from './base-layer';
var BulletLayer = /** @class */ (function (_super) {
    __extends(BulletLayer, _super);
    function BulletLayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'bullet';
        return _this;
    }
    BulletLayer.getDefaultOptions = function () {
        return _.deepMix({}, _super.getDefaultOptions.call(this), {
            value: 0,
            xField: 'x',
            yField: 'value',
        });
    };
    /** @override */
    BulletLayer.prototype.drawBullets = function () {
        var options = this.options;
        var container = this.view.get('elements')[0].get('container');
        var shape = this.view.get('elements')[0].get('shapeContainer');
        this.drawBullet(container, shape.getBBox(), options.value);
        this.canvas.draw();
    };
    /** @override */
    BulletLayer.prototype.adjustYAxisOptions = function (options) {
        options.yAxis.maxLimit = Math.max(options.max, options.value);
    };
    /** @override */
    BulletLayer.prototype.adjustDataOptions = function (options) {
        var _a, _b;
        var data = [];
        var rangeValues = options.range.map(function (d) { return (d / 100) * (options.max - options.min); });
        if (rangeValues[0] !== 0) {
            data.push((_a = {
                    x: '1'
                },
                _a[STACK_FIELD] = "" + rangeValues[0],
                _a.value = rangeValues[0],
                _a));
        }
        for (var i = 1; i < rangeValues.length; i += 1) {
            data.push((_b = {
                    x: '1'
                },
                _b[STACK_FIELD] = options.range[i - 1] + "-" + options.range[i],
                _b.value = rangeValues[i] - rangeValues[i - 1],
                _b));
        }
        options.data = data;
    };
    return BulletLayer;
}(BaseBulletLayer));
export default BulletLayer;
registerPlotType('bullet', BulletLayer);
//# sourceMappingURL=layer.js.map